import { Component, inject, Input, OnInit, signal, Signal } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { IonicModule } from "@ionic/angular";

import { SharedModule } from "../../../../shared/shared.module";
import { MedicationInputErrorComponent } from "../../../components/medication-input-error/medication-input-error.component";
import { SingleSelectFieldComponent } from "../../../components/single-select-field/single-select-field.component";
import { Option } from "../../../components/single-select-list/single-select-list.component";
import {
	DepartmentValue,
	FoundMedicationIncidentModel,
	OTHER_DEPARTMENT,
	RoomValue,
} from "../../services/found-medication-incident-model.service";

export interface LocationFormControls {
	departmentId: FormControl<DepartmentValue>;
	roomId?: FormControl<RoomValue>;
	description?: FormControl<string>;
}

@Component({
	selector: "ic-found-medication-incident-location",
	imports: [SharedModule, IonicModule, MedicationInputErrorComponent, SingleSelectFieldComponent],
	templateUrl: "./location.component.html",
	styleUrls: ["./location.component.scss"],
})
export class LocationComponent implements OnInit {
	private readonly model = inject(FoundMedicationIncidentModel);

	protected readonly departmentOptions: Signal<Option<DepartmentValue>[]> = this.model.departmentsOptions;
	// @ts-expect-error TS2345
	protected readonly roomOptions = signal<Option<RoomValue>[]>(undefined);

	// @ts-expect-error TS2564
	@Input() label: string;
	// @ts-expect-error TS2564
	@Input() form: FormGroup<LocationFormControls>;

	ngOnInit() {
		// @ts-expect-error TS2531
		this.form.get("departmentId").valueChanges.subscribe((departmentId) => {
			this.roomOptions.set(
				departmentId && departmentId !== OTHER_DEPARTMENT ? this.model.getRoomOptionsForDepartment(departmentId) : [],
			);
		});
	}
}
